import React, {useEffect, useState} from 'react';
import './App.css';
import AntSidebar from "./components/layout/AntSidebar";
import {Alert, Layout} from "antd";
import * as ReactGA from "react-ga";
import {AppContext} from "./components/libs/ContextLibs";
import {Auth} from "aws-amplify";
import {Switch} from "react-router-dom";
import AuthenticatedRoute from "./components/utils/AuthenticatedRoute";
import Home from "./components/pages/Home";
import Dashboard from "./components/pages/Dashboard";
import EmbedDashboard from "./components/pages/EmbedDashboard";
import Folder from "./components/pages/Folder";
import UserPreferences from "./components/pages/UserPreferences";
import UnauthenticatedRoute from "./components/utils/UnauthenticatedRoute";
import Login from "./components/auth/Login";
import ResetPasswordPublic from "./components/layout/ResetPasswordPublic";

const {Content} = Layout;

ReactGA.initialize('UA-168702636-1');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [user, setUser] = useState(null);
    const [userNameOverride, setUserNameOverride] = useState(null);
    const [isUserNameOverride, setIsUserNameOverride] = useState(false);

    useEffect(() => {
        const onLoad = () => {
            try {
                Auth.currentSession().then(async (res) => {
                    setUser(await Auth.currentUserInfo());
                    setIsAuthenticated(true);
                });

            } catch (e) {
                if (e !== 'No current user') {
                    console.log(e);
                }
            }
            setIsAuthenticating(false);
        };
        onLoad();
    }, []);

    // function checkHealth() {
    //     const interval = setInterval(() => {
    //         axios.get(process.env.REACT_APP_API_SERVER + "/health").catch((err)=>{
    //             console.log(err);
    //         })
    //     }, 3600000);
    //     return () => clearInterval(interval);
    // }


    async function handleLogout() {
        await Auth.signOut();
        setIsAuthenticated(false);
    }

    return (
        !isAuthenticating && (
            <>
                <Layout style={{minHeight: '100vh'}} className="layout" id="App">
                    <AppContext.Provider value={{
                        isAuthenticated,
                        setIsAuthenticated,
                        user,
                        setUser,
                        userNameOverride,
                        setUserNameOverride,
                        isUserNameOverride,
                        setIsUserNameOverride
                    }}>
                        <AntSidebar isAuthenticated={isAuthenticated} logout={handleLogout}/>
                        <Content>
                            {
                                (isUserNameOverride && userNameOverride) &&
                                <Alert message={"Viewing as " + userNameOverride} type="warning"/>
                            }
                            <Switch>
                                <AuthenticatedRoute path="/" exact>
                                    <Home user={user}/>
                                </AuthenticatedRoute>
                                <AuthenticatedRoute path="/dashboard/:id" exact>
                                    <Dashboard user={user}/>
                                </AuthenticatedRoute>
                                <AuthenticatedRoute path="/embed-dashboard/:id" exact>
                                    <EmbedDashboard user={user}/>
                                </AuthenticatedRoute>
                                <AuthenticatedRoute path="/folder" exact>
                                    <Folder user={user}/>
                                </AuthenticatedRoute>
                                <AuthenticatedRoute path="/user-preferences" exact>
                                    <UserPreferences user={user}/>
                                </AuthenticatedRoute>

                                <UnauthenticatedRoute exact path="/login" component={Login}/>
                                <UnauthenticatedRoute exact path="/reset-temp-password" component={ResetPasswordPublic}/>
                            </Switch>
                        </Content>
                    </AppContext.Provider>
                </Layout>
            </>
        )
    );


}

export default App;